<div
  [formGroup]="formGroup"
  [ngClass]="{
    field: true,
    wide: config.UIData?.isWide,
    busy: isBusy,
    'no-label': config.UIData?.hideLabel,
    hidden: isHidden,
    masked: isMasked,
    'big-field': config.fieldType === FieldType.LongText,
  }">
  <ti-form-field-label *ngIf="!config.UIData?.hideLabel" [config]="config" [self]="self"></ti-form-field-label>
  <!--todo: may be we should check all decimals settings for numerictextbox-fields  -->
  <kendo-numerictextbox
    *ngIf="config.fieldType === FieldType.Number"
    [readonly]="isMasked"
    [placeholder]="config.UIData?.placeholder || ''"
    [title]="config.customFieldSettings?.fieldTitle || config.fieldTitle"
    [spinners]="config.customFieldSettings?.spinners"
    [format]="config.customFieldSettings?.format || ''"
    [min]="
      config.customFieldSettings?.minValue !== undefined
        ? config.customFieldSettings?.minValue
        : serverBoundaries.minNumberValue
    "
    [max]="
      config.customFieldSettings?.maxValue !== undefined
        ? config.customFieldSettings?.maxValue
        : serverBoundaries.maxNumberValue
    "
    [decimals]="config.customFieldSettings?.decimals"
    [autoCorrect]="config.customFieldSettings?.autoCorrect"
    [step]="config.customFieldSettings?.step || 1"
    [id]="config.fieldName"
    [focusableId]="config.fieldName"
    [formControlName]="config.fieldName"
    [ngStyle]="config.customFieldSettings?.styles">
    <ng-template *ngIf="config.UIData.hasClearButton" kendoSuffixTemplate>
      <i
        (click)="deselect()"
        class="fa fa-times-circle clear-button-numeric"
        [ngClass]="{ 'visibility-hidden': isClearButtonHidden() }"></i>
    </ng-template>
  </kendo-numerictextbox>

  <div
    *ngIf="config.fieldType === FieldType.Text || config.fieldType === FieldType.LongText"
    class="form-input-container">
    <kendo-textbox
      *ngIf="config.fieldType === FieldType.Text"
      tiTrimValue
      [tiOverflowTooltip]="overflowTooltipOptions"
      [placeholder]="config.UIData?.placeholder || ''"
      [readonly]="isMasked"
      [title]="config.fieldTitle"
      class="k-textbox"
      [class.with-clear-button]="config.UIData.hasClearButton"
      [id]="config.fieldName"
      [name]="config.fieldName"
      [formControlName]="config.fieldName"></kendo-textbox>
    <kendo-textarea
      #fibtextarea
      *ngIf="config.fieldType === FieldType.LongText"
      [readonly]="isMasked"
      [autoSize]="true"
      [title]="config.fieldTitle"
      [placeholder]="config.UIData?.placeholder || ''"
      [class.with-clear-button]="config.UIData.hasClearButton"
      [id]="config.fieldName"
      [name]="config.fieldName"
      [formControlName]="config.fieldName"
      [ngStyle]="
        config.customFieldSettings?.styles || (fibtextarea && fibtextarea.style && setStyleAutoHeight(fibtextarea))
          ? config.customFieldSettings?.styles
          : config.customFieldSettings?.styles
      "></kendo-textarea>
    <i
      *ngIf="config.UIData.hasClearButton"
      (click)="deselect()"
      class="fa fa-times-circle clear-button"
      [ngClass]="{ 'visibility-hidden': isClearButtonHidden() }"></i>
  </div>
</div>

<div
  *ngIf="getError() && !config?.UIData?.hideError"
  [ngClass]="{
    'error-message': true,
    wide: config.UIData?.isWide,
    'no-label': config.UIData?.hideLabel,
    hidden: isHidden,
  }">
  {{ getError() }}
</div>
